import React from 'react';
import './PageBackground.css';

export default function PageBackground() {
  return (
    <>
      <img src="/img/BG2.jpg" alt="" className="page-bg page-bg-desktop" />
      <img src="/img/MOB_BG.png" alt="" className="page-bg page-bg-mobile" />
    </>
  );
}
